import { RouteFactory } from "@app/routePaths";
import Ad from "@components/Advertisement/Ad";
import AdSettings from "@components/Advertisement/AdSettings";
import Container from "@components/Container/Container";
import GAData from "@components/GAData/GAData";
import Header from "@components/Header/Header";
import MetaTags from "@components/MetaTags/MetaTags";
import { useWindowSize } from "@hooks/useWindowSize";
import SectionHeading from "@pages/Section/components/SectionHeading";
import ArticleList from "@pages/ZhHans/components/ArticleList/ArticleList";
import { ZhHansPayload } from "@pages/ZhHans/utils/types";
import { useDetectAdBlock } from "adblock-detect-react";

/**
 * The content of the zh-hans page.
 * FIGMA: https://www.figma.com/design/rR8akVWS3SksIyaOSqetu4/WEB-BAU-2025?node-id=16171-18324&t=QZPAjkqVKrSzpWQN-4
 * */
const ZhHansPageContent = ({
  data: { title, articles },
}: Pick<ZhHansPayload, "data">): React.ReactElement => {
  const adblockDetected = useDetectAdBlock();
  const { isScreenLG } = useWindowSize();

  const headingText = "商业时报中文版 (beta)";
  const relativePath = RouteFactory.zhHans;

  return (
    <div data-testid="zh-hans-page-content-component" className="w-full">
      <AdSettings
        adNames={["prestitial", "lb1", "imu2", "catfish"]}
        path={relativePath}
        adTargets={[{ key: "page", value: "listing" }]}
      />

      <GAData
        title={title}
        level2="zh-hans"
        adblocker={adblockDetected ? 1 : 0}
        language="sc"
      />

      <MetaTags
        title={title}
        description={
          "《商业时报》中文版 (beta)：新加坡及国际商业新闻的权威来源。每日更新深度报道、市场分析和财经资讯"
        }
        slug={relativePath}
        ogSiteName={title}
        ogLocale="zh_Hans"
      />

      <Ad
        adType="lb1"
        className="flex min-h-[calc(50px+0.50rem)] flex-col items-center justify-center border-b border-gray-175 bg-gray-125 py-1 text-center md:py-3 lg:min-h-[calc(250px+1.5rem)]"
      />

      <Header />

      <Container>
        <SectionHeading text={headingText} className="mb-6" hasBorder />

        <div className="grid gap-6 lg:grid-cols-3">
          <ArticleList cardProps={articles} className="lg:col-span-2" />

          {isScreenLG ? (
            <div className="lg:col-span-1">
              <Ad
                adType="imu2"
                className="flex flex-col items-center justify-center lg:!sticky lg:top-18"
              />
            </div>
          ) : null}
        </div>
      </Container>

      <Ad adType="catfish" />
      <Ad adType="prestitial" />
    </div>
  );
};

export default ZhHansPageContent;
